import 'twin.macro';

import { Badge, Banner, Button, Stack, Text } from '@cheqroom/ui';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate } from 'react-router-dom';

import { Step } from '../../App';
import { AuthFlowHeader } from '../AuthFlowHeader';
import { StyledListItem } from '../SelectableListStep/SelectableListItem.styles';
import { SelectableListStep } from '../SelectableListStep/SelectableListStep';
import { useSelectOrganisationForLogin } from './api.hooks';

export const SelectOrganisationForLoginStep: FC = () => {
	const { t } = useTranslation();
	const { organisations, email, error, selectOrganisation, changeEmail } = useSelectOrganisationForLogin();

	if (organisations.length === 0) {
		return <Navigate to={Step.ENTER_EMAIL} />;
	}

	return (
		<SelectableListStep.Layout
			header={
				<AuthFlowHeader
					spacing="loose"
					heading={t('select_organisation_for_login.header')}
					subheading={t('select_organisation_for_login.subheading')}
				>
					{error && <Banner variation="error">{error}</Banner>}
				</AuthFlowHeader>
			}
			listSection={
				<Stack tw="w-full mt-0" align="center" spacing="extraLoose" vertical>
					<SelectableListStep.ScrollableList itemCount={organisations.length}>
						{organisations.map((organisation) => (
							<StyledListItem
								key={organisation.organisationId}
								aria-label={t('select_aria_label', { name: organisation.organisationName })}
								onClick={() => selectOrganisation(organisation.organisationId)}
							>
								<SelectableListStep.ListItem
									name={organisation.organisationName}
									trailing={
										<Badge>
											{t('select_organisation_for_login.workspace_count', {
												count: organisation.workspaces.length,
											})}
										</Badge>
									}
								/>
							</StyledListItem>
						))}
					</SelectableListStep.ScrollableList>

					<Stack align="center" spacing="extraTight" vertical>
						{email && <Text align="center">{email}</Text>}
						<Button size="medium" type="button" inverted onClick={changeEmail}>
							{t('select_organisation_for_login.try_different_email')}
						</Button>
					</Stack>
				</Stack>
			}
		/>
	);
};
